// eslint-disable-next-line import/no-anonymous-default-export
export default (date1, date2) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const firstDate = new Date(date1);
  firstDate.setDate(firstDate.getDate() - 1);
  const secondDate = new Date(date2);

  return Math.round(Math.abs((firstDate - secondDate) / oneDay));
};
